export default "__VITE_ASSET__BCT08cXI__"